<template lang="pug">
  canvas.Constellation(ref="canvas" :width="containerWidth" :height="containerHeight")
</template>

<script>
  export default {
    name: "Constellation",
    props: {
      originalPoints: {
        type: Array,
        default: () => [
          [
            {x: 85, y: 481, arc: 3},
            {x: 119, y: 476, arc: 3},
            {x: 100, y: 530, arc: 3},
            {x: 150, y: 536, arc: 3},
            {x: 139, y: 511, arc: 3},
          ]
        ]
      },
    },
    data() {
      return {
        points: this.originalPoints,
        ctx: null,
        range: 10,      // 每个点的移动范围
        iterTimes: 200, // 循环次数
        iterNumber: 0,       // 当前循环了的次数
        targetPointsList: null,
      };
    },
    watch: {},
    computed: {
      containerWidth() {
        return window.innerWidth;
      },
      containerHeight() {
        return 600;
      },
      iterNum: {
        get() {
          return this.iterNumber;
        },
        set(val) {
          this.iterNumber = val % this.iterTimes;
        }
      },
      targetPoints() {
        const points = this.points;
        const randomPoint = () => Math.random() * this.range - this.range / 2;
        if (this.iterNum === 0) {
          this.targetPointsList = points.map(item => item.map(point => {
            return {
              ...point,
              x: point.x + randomPoint(),
              y: point.y + randomPoint(),
            }
          }));
        }
        return this.targetPointsList;
      },
    },
    methods: {
      move() {
        for (let i = 0; i < this.points.length; i++) {
          for (let j = 0; j < this.points[i].length; j++) {
            this.points[i][j].x += (this.targetPoints[i][j].x - this.points[i][j].x) / (this.iterTimes - this.iterNum);
            this.points[i][j].y += (this.targetPoints[i][j].y - this.points[i][j].y) / (this.iterTimes - this.iterNum);
          }
        }
        this.iterNum++;
      },
      draw() {
        const points = this.points;
        const ctx = this.ctx;
        ctx.fillStyle = '#2abeff';
        ctx.strokeStyle = '#2abeff';
        for (let i = 0; i < points.length; i++) {
          for (let j = 0; j < points[i].length; j++) {
            const point = points[i][j];
            ctx.beginPath();
            ctx.arc(point.x, point.y, point.arc, 0, 2 * Math.PI);
            ctx.fill();
            
            if (points[i][j + 1]) {
              ctx.beginPath();
              ctx.lineTo(points[i][j + 1].x, points[i][j + 1].y);
              ctx.lineTo(point.x, point.y);
              ctx.stroke();
            }
          }
        }
      },
      animation() {
        this.ctx.clearRect(0, 0, this.containerWidth, this.containerHeight);
        this.move();
        this.draw();
        window.requestAnimationFrame(this.animation);
      },
    },
    mounted() {
      const canvas = this.$refs['canvas'];
      this.ctx = canvas.getContext("2d");
      window.requestAnimationFrame(this.animation);
    },
  };
</script>

<style scoped lang="stylus">
  .Constellation {
    position absolute
    top 0
    left 0
  }
</style>
